import { render } from "./List.vue?vue&type=template&id=43df4506&scoped=true"
import script from "./List.vue?vue&type=script&lang=ts"
export * from "./List.vue?vue&type=script&lang=ts"

import "./List.vue?vue&type=style&index=0&id=43df4506&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-43df4506"

export default script